import React from 'react';

export const FiverrIcon: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className = '', ...rest } = props;
  return (
    <div
      className={`${className} flex items-center justify-center rounded-full overflow-hidden transition-transform duration-300 hover:scale-110`}
      title="Fiverr Level 2 Seller"
      {...rest}
    >
      <img
        src="https://nikolasyuri.com.br/wp/wp-content/uploads/2026/08/Fiverr_Icon.png"
        alt="Fiverr Logo"
        className="w-full h-full object-contain"
        loading="lazy"
      />
    </div>
  );
};
